import { DEFAULT_PIN_THEME_ID, PinTheme } from '@lessonup/pins-shared';

const defaultPinComponentSettings = {
  ANSWER_AREA: {
    backgroundColor: '#FFFFFF',
  },
  HOTSPOT: {
    borderColor: '#000000',
    borderSize: 8,
    backgroundColor: '#FFFFFF',
    innerColor: '#000000',
    contentTextColor: '#000000',
    contentBackgroundColor: '#FFFFFF',
    contentBorderColor: '#000000',
    shadow: 'NONE',
  },
  SHAPE: {
    fillColor: '#0931AA',
    borderColor: '#000000',
    borderSize: 0,
    shadow: 'NONE',
  },
  TEXT: {
    fontColor: '#001343',
    borderColor: '#000000',
    borderSize: 0,
    shadow: 'NONE',
    borderRadius: 0,
    paragraphSpacing: 0,
    lineHeight: 1.5,
  },
  LINE: {
    fillColor: '#000000',
    shadow: 'NONE',
  },
  CATEGORY_AREA: {
    shadow: 'NONE',
    borderColor: '#000000',
    borderSize: 0,
    backgroundColor: '#FFFFFF',
    defaultCategorySyle: {
      backgroundColor: '#d2d1ffa1',
      borderColor: '#82828245',
      borderSize: 2,
      borderStyle: 'dashed',
      color: '#001343',
    },
  },
  UNEDITABLE_SHAPE: {
    shadow: 'NONE',
  },
  SPINNER: {
    sliceColors: {
      first: {
        backgroundColor: '#0D46F2',
        textColor: '#FFFFFF',
      },
      second: {
        backgroundColor: '#0B3FDA',
        textColor: '#FFFFFF',
      },
      third: {
        backgroundColor: '#0A38C2',
        textColor: '#FFFFFF',
      },
    },
  },
  IMAGE: {
    shadow: 'NONE',
    borderColor: '#000000',
    borderSize: 0,
  },
  TIMER: {
    shadow: 'HARD',
    backgroundColor: '#FFFFFF',
    foregroundColor: '#E4E5E7',
    borderColor: '#DFE1E7',
    borderSize: 1,
    fontColor: '#001343',
    primaryButton: {
      accentColor: '#4E7FFF',
      accentFontColor: '#FFFFFF',
      borderSize: 1,
      backgroundColor: '#FFFFFF',
      borderColor: '#DFE1E7',
      fontColor: '#001343',
    },
    secondaryButton: {
      borderSize: 1,
      backgroundColor: '#FFFFFF',
      borderColor: '#DFE1E7',
      fontColor: '#001343',
    },
  },
  VIDEO: {},
  UNSUPPORTED: {},
  FILL_IN_THE_BLANKS_AREA: {
    backgroundColor: '#FFFFFF',
    fontFamily: 'DM Sans',
    fontSize: '16px',
    fontColor: '#001343',
  },
  DROP_ZONE: {
    borderColor: '#A64EFF',
    borderSize: 3,
    borderRadius: 16,
    fontColor: '#001343',
  },
  AUDIO: {
    borderColor: '#D1D5DB',
    borderColorProgress: '#3B82F6',
    backgroundColor: '#FFFFFF',
    innerColor: '#000000',
    contentTextColor: '#000000',
    contentBackgroundColor: '#FFFFFF',
    contentBorderColor: '#D1D5DB',
    shadow: 'NONE',
  },
} satisfies PinTheme['default']['pinComponents'];

const interactivePinComponentSettings: PinTheme['interactive']['pinComponents'] = {
  ...defaultPinComponentSettings,
} satisfies PinTheme['interactive']['pinComponents'];

export const defaultPinTheme = {
  id: DEFAULT_PIN_THEME_ID,
  name: 'Default',
  createdAt: '2027-07-03T10:32:20.271Z',
  themeId: '0',
  typography: {
    title: {
      fontFamily: 'Plus Jakarta Sans',
      fontSize: '48px',
      fontWeight: '700',
    },
    headline: {
      fontFamily: 'Plus Jakarta Sans',
      fontSize: '32px',
      fontWeight: '700',
    },
    subheadline: {
      fontFamily: 'Plus Jakarta Sans',
      fontSize: '24px',
      fontWeight: '700',
    },
    normalText: {
      fontFamily: 'DM Sans',
      fontSize: '24px',
      fontWeight: '400',
    },
    smallText: {
      fontFamily: 'DM Sans',
      fontSize: '18px',
      fontWeight: '400',
    },
    chart: {
      fontFamily: 'DM Sans',
      fontSize: '18px',
      fontWeight: '400',
    },
    table: {
      fontFamily: 'DM Sans',
      fontSize: '18px',
      fontWeight: '400',
    },
  },
  default: {
    pin: {
      backgroundColor: '#FFFFFF',
    },
    pinComponents: defaultPinComponentSettings,
  },
  interactive: {
    answerCard: {
      backgroundColor: 'blue',
      textColor: '#001343',
      correctnessColors: {
        correct: '#42A546',
        partiallyCorrect: '#C37C12',
        incorrect: '#EC484D',
      },
    },
    pin: {
      backgroundColor: '#D2D1FF',
    },
    pinComponents: interactivePinComponentSettings,
  },
} satisfies PinTheme;
